import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';


@Injectable({
    providedIn: 'root'
})
export class ContactService {
    public requestAPIurl: any = environment.apiURL;
    constructor(private http: HttpClient) { }

    public sendEmail(payload) {
        return this.http.post(`${this.requestAPIurl}/api/mail/send`, payload)
    }

}
